import { Link, useSearchParams } from 'react-router-dom';
import { ArrowRight, Target, Map, Calc, GraduationCap, Sigma } from '../components/Icons.jsx';
import SubNav from '../components/SubNav.jsx';

const tools = [
  { to: '/score-converter', icon: Calc, title: 'Score converter', body: 'Turn raw mock scores into the scaled UCAT total.', tag: 'score' },
  { to: '/ucat-converter', icon: Sigma, title: 'UCAT 2024 ↔ 2025', body: 'Compare scores from the 4-section format to the new 3-section format.', tag: 'score' },
  { to: '/grade-check', icon: GraduationCap, title: 'Grade check', body: 'A-levels or IB vs entry bars at all 28 UK med schools.', tag: 'grades' },
  { to: '/school-matcher', icon: Map, title: 'School matcher', body: '11 questions + your postcode. Ranks schools by fit.', tag: 'shortlist' },
  { to: '/where-can-i-apply', icon: Target, title: 'Where can I apply', body: 'Filter all 28 schools by your UCAT score.', tag: 'shortlist' }
];

const subNav = [
  { to: '/plan', label: 'All', end: true },
  { to: '/plan?tab=score', label: 'Score tools' },
  { to: '/plan?tab=grades', label: 'Grades' },
  { to: '/plan?tab=shortlist', label: 'Shortlist' }
];

export default function Plan() {
  const [params] = useSearchParams();
  const tab = params.get('tab');
  const visible = tab ? tools.filter((t) => t.tag === tab) : tools;

  return (
    <>
      <div className="page-head">
        <h1>Plan your application</h1>
        <p className="subtitle">Score, grades, preferences, fit. Land on your final four UCAS choices.</p>
      </div>

      <SubNav items={subNav} />

      <div className="r-grid-2">
        {visible.map((t) => (
          <Link key={t.to} to={t.to} className="parents-card" style={{ textDecoration: 'none', color: 'inherit', cursor: 'pointer' }}>
            <div className="icon-wrap"><t.icon /></div>
            <h3 style={{ margin: '8px 0 6px' }}>{t.title}</h3>
            <p style={{ color: 'var(--text-2)', fontSize: 14, margin: 0 }}>{t.body}</p>
            <span style={{ marginTop: 12, color: 'var(--accent)', fontSize: 14, fontWeight: 600, display: 'inline-flex', alignItems: 'center', gap: 6 }}>Open <ArrowRight width="14" height="14" /></span>
          </Link>
        ))}
      </div>
    </>
  );
}
